<div class="p-2">
  <div *ngIf="duplicateUsers.length > 0">
    <h3 class="text-danger">Duplicate Users - Please fix the email address for the following users first before making any changes here.</h3>
    <div *ngFor="let user of duplicateUsers">
      <div>{{user.email}}</div>
      <div *ngFor="let user of user.users">
        <div>{{user.name}} {{user.surname}} {{user.email}} {{user.phoneNumber}}</div>
      </div>
    </div>
  </div>
  
  <form [formGroup]="form" id="edit-member" (ngSubmit)="submitForm()" validateOnSubmit>
    <div class="row mt-2 fade-in-top">
      <div class="col-12 col-sm-6 mb-3">
        <label class="form-label" for="member-name">
          {{ '::Name' | abpLocalization }} *
        </label>
        <input id="member-name" formControlName="name" class="form-control" autofocus />
        <div *ngIf="form.get('name').invalid && (form.get('name').dirty || form.get('name').touched)">
          <small class="text-danger" *ngIf="form.get('name').errors?.['required']">Name is required</small>
        </div>
      </div>
      
      <div class="col-12 col-sm-6 mb-3">
        <label class="form-label" for="member-surname">
          {{ '::SurName' | abpLocalization }} *
        </label>
        <input id="member-surname" formControlName="surname" class="form-control" />
        <div *ngIf="form.get('surname').invalid && (form.get('surname').dirty || form.get('surname').touched)">
          <small class="text-danger" *ngIf="form.get('surname').errors?.['required']">Surname is required</small>
        </div>
      </div>
      
      <div class="col-12 col-sm-6 mb-3">
        <label class="form-label" for="member-email">
          {{ '::Email' | abpLocalization }} *
        </label>
        <input id="member-email" formControlName="email" class="form-control" />
        <div *ngIf="form.get('email').invalid && (form.get('email').dirty || form.get('email').touched)">
          <small class="text-danger" *ngIf="form.get('email').errors?.['required']">Email is required</small>
          <small class="text-danger" *ngIf="form.get('email').errors?.['email']">Please enter a valid email</small>
        </div>
      </div>
      
      <div class="col-12 col-sm-6 mb-3">
        <label class="form-label" for="member-phone-number">
          {{ '::PhoneNumber' | abpLocalization }} *
        </label>
        <input id="member-phone-number" formControlName="phoneNumber" class="form-control" placeholder="(999)-999 9999" />
        <div *ngIf="form.get('phoneNumber').invalid && (form.get('phoneNumber').dirty || form.get('phoneNumber').touched)">
          <small class="text-danger" *ngIf="form.get('phoneNumber').errors?.['required']">Phone number is required</small>
          <small class="text-danger" *ngIf="form.get('phoneNumber').errors?.['mask']">Please enter a valid phone number format: (999)-999 9999</small>
        </div>
      </div>
      
      <div class="row mb-20" >
        <div class="col-12">
          <strong><label>Enter Address<span class="give-required-indicator">*</span></label></strong>
        </div>
        <div class="col-12">
          <app-google-places class="custom-control"
          (setAddress)="getAddress($event)" adressType="geocode"></app-google-places>
          <span *ngIf="form.invalid && (form.controls.addressLine1?.errors?.required || form.controls.addressLine3?.errors?.required || form.controls.postalCode?.errors?.required)" class="text-danger">
            Address is required.
          </span>
        </div>
      </div>
      
      <div class="row nb-20" >
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label" for="member-address-line1">
            {{ '::Address' | abpLocalization }} *
          </label>
          <input id="member-address-line1" formControlName="addressLine1" class="form-control" />
          <div *ngIf="form.get('addressLine1').invalid && (form.get('addressLine1').dirty || form.get('addressLine1').touched)">
            <small class="text-danger" *ngIf="form.get('addressLine1').errors?.['required']">Address is required</small>
          </div>
        </div>
        
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label" for="member-address-line2">
            {{ '::City' | abpLocalization }} *
          </label>
          <input id="member-address-line2" formControlName="addressLine2" class="form-control" />
          <div *ngIf="form.get('addressLine2').invalid && (form.get('addressLine2').dirty || form.get('addressLine2').touched)">
            <small class="text-danger" *ngIf="form.get('addressLine2').errors?.['required']">City is required</small>
          </div>
        </div>
        
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label" for="member-address-line3">
            {{ '::Province' | abpLocalization }} *
          </label>
          <input id="member-address-line3" formControlName="addressLine3" class="form-control" />
          <div *ngIf="form.get('addressLine3').invalid && (form.get('addressLine3').dirty || form.get('addressLine3').touched)">
            <small class="text-danger" *ngIf="form.get('addressLine3').errors?.['required']">Province is required</small>
          </div>
        </div>
        
        <div class="col-12 col-sm-6 mb-3">
          <label class="form-label" for="member-postalcode">
            {{ '::PostalCode' | abpLocalization }} *
          </label>
          <input id="member-postalcode" formControlName="postalCode" class="form-control" />
          <div *ngIf="form.get('postalCode').invalid && (form.get('postalCode').dirty || form.get('postalCode').touched)">
            <small class="text-danger" *ngIf="form.get('postalCode').errors?.['required']">Postal code is required</small>
          </div>
        </div>
      </div>
    </div>
  </form>
  
  <div class="row mt-3">
    <div class="col-12" *ngIf="userAdded">
      User Created.
    </div>
    <div class="col-12" *ngIf="subscriptionAdded">
      Subscriptions Added.
    </div>
    <div class="col-12" *ngIf="emailSent">
      Welcome Email Sent
    </div>
  </div>
  
  <div class="row mt-3">
    <div class="col-12 text-end">
      <button type="button" class="btn btn-secondary me-2" (click)="cancel()">
        {{ 'AbpUi::Cancel' | abpLocalization }}
      </button>
      
      <button class="btn btn-primary" type="button" [disabled]="form.invalid || duplicateUsers.length > 0 || isModalBusy" (click)="submitForm()">
        <i class="fa fa-check me-1"></i>
        {{ 'AbpUi::Save' | abpLocalization }}
      </button>
    </div>
  </div>
</div>
